import { KioskResource } from './KioskResource';

export class BlogAndKioskResource {
    rid: number;
	kiosk: KioskResource;
}